
import { TIMEOUT } from '../../config/designSystem/Colors';
import { useEffect } from 'react';
import { useStores } from '../useStores';

export type fetchedContentType = 'CONTENT_TEXT' | 'CONTENT_VIDEO' | 'CONTENT_AUDIO' | 'SURVEY' | 'QUESTION' | 'EXERCISE' | 'ACTIVITY'


export const useFetchedContent = (contentId: string, type: fetchedContentType) => {

  const rootStore = useStores();
  let error = false;
  let loading = false;
  let data = null;

  useEffect(() => {
    if(contentId) {
      switch (type) {
      case 'CONTENT_TEXT':
      case 'CONTENT_VIDEO':
      case 'CONTENT_AUDIO':
        rootStore?.content.fetchContentIfNotExist(contentId);
        setTimeout(()=> {
          rootStore?.content.setError(contentId);
        }, TIMEOUT);
        break;
      case 'SURVEY':
        rootStore?.survey.loadSurvey(contentId, true, true);
        // setTimeout(()=> {
        //   rootStore?.survey.setFetchError(contentId, 'Timeout.');
        // }, TIMEOUT);
        break;
      case 'QUESTION':
        rootStore?.question.fetchQuestionIfNotExist(contentId);
        setTimeout(()=> {
          rootStore?.question.setError(contentId);
        }, TIMEOUT);
        break;
      case 'EXERCISE':
        rootStore?.exercise.fetchExerciseIfNotExist(contentId);
        setTimeout(()=> {
          rootStore?.exercise.setError(contentId);
        }, TIMEOUT);
        break;
      case 'ACTIVITY':
        rootStore?.activity.fetchActivityIfNotExist(contentId);
        setTimeout(()=> {
          rootStore?.activity.setError(contentId);
        }, TIMEOUT);
        break;
      }
    }
  }, [contentId]);

  if(!contentId) { return {data: undefined, loading: true, error: false}; }

  if(type === 'CONTENT_TEXT' || type === 'CONTENT_VIDEO' || type === 'CONTENT_AUDIO') {
    error = rootStore?.content.hasError(contentId);
    loading = !rootStore?.content.isReady(contentId);
    data = rootStore?.content.getContent(contentId);
  }
  if(type === 'SURVEY') {
    error = rootStore?.survey.hasFetchError(contentId);
    loading = !rootStore?.survey.isReady(contentId);
    data = rootStore?.survey.getSurvey(contentId);
  }
  if(type === 'QUESTION') {
    error = rootStore?.question.hasError(contentId);
    loading = !rootStore?.question.isReady(contentId);
    data = rootStore?.question.getQuestion(contentId);
  }
  if(type === 'EXERCISE') {
    error = rootStore?.exercise.hasError(contentId);
    loading = !rootStore?.exercise.isReady(contentId);
    data = rootStore?.exercise.getExercise(contentId);
  }
  if(type === 'ACTIVITY') {
    error = rootStore?.activity.hasError(contentId);
    loading = !rootStore?.activity.isReady(contentId);
    data = rootStore?.activity.getActivity(contentId);
  }





  return {data, loading, error};
};